import { match, P } from 'ts-pattern';
import { ConversationItemUnion } from '@lgg/isomorphic/types/__generated__/graphql';

export const getContactInteractionCreationDate = (interaction: ConversationItemUnion) => {
  return match(interaction)
    .with(
      { __typename: P.union('ContactNote', 'ConversationNote') },
      (note) => note.createdAt,
    )
    .otherwise((interaction) => interaction.occurredAt);
};

/**
 * Decides whether a polling result contains an item that should raise the
 * "New Messages" bubble.
 *
 * Polling fetches the latest items in the conversation, but two kinds of items
 * must never trigger the bubble:
 *  - Timeline events (status/stage/task changes); they are not messages.
 *  - Items this user just created (e.g. a message they sent or a note they
 *    added). Those are already on screen, yet polling re-fetches them and would
 *    otherwise flag them as brand new.
 *
 * `locallyCreatedItemIds` is tracked via a ref so this check is immune to the
 * stale state the polling closure can hold right after sending a message.
 */
export const pollResultHasUnseenIncomingItem = (
  polledNodes: ConversationItemUnion[],
  locallyCreatedItemIds: ReadonlySet<string>,
): boolean => {
  return polledNodes.some((polledNode) => {
    if (polledNode.__typename.startsWith('ContactTimeline')) {
      return false;
    }

    return !locallyCreatedItemIds.has(String(polledNode.id));
  });
};
